import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ViewImageDialogComponent } from './view-image-dialog.component';


@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [ViewImageDialogComponent],
    declarations: [ViewImageDialogComponent],
    providers: [],
})
export class ViewImageDialogModule { }
